/**
 * Lucide icon per page-component type, for the builder palette + canvas
 * labels. Explicit map (not a dynamic `icons[...]` lookup) so the bundle only
 * pulls the icons we actually use.
 */
import {
  BarChart3,
  CalendarDays,
  CheckSquare,
  ClipboardList,
  Code2,
  Columns3,
  Copy,
  FileText,
  Filter,
  Gauge,
  Hash,
  Heading,
  Image,
  Info,
  KanbanSquare,
  Layout,
  LayoutPanelTop,
  Link2,
  List,
  ListTree,
  MessageSquare,
  Minus,
  MousePointerClick,
  PanelRight,
  Pilcrow,
  Rows3,
  Sparkles,
  Square,
  SquarePen,
  SquareStack,
  Table,
  Tag,
  TextCursorInput,
  TrendingUp,
  Type,
  type LucideIcon,
} from "lucide-react";

const BY_TYPE: Record<string, LucideIcon> = {
  page: Layout,
  container: Columns3,
  card: SquareStack,
  tabs: LayoutPanelTop,
  tab: Square,
  modal: SquareStack,
  drawer: PanelRight,
  page_ref: Copy,
  text: Type,
  heading: Heading,
  image: Image,
  divider: Minus,
  stat: Gauge,
  callout: Info,
  badge: Tag,
  progress: TrendingUp,
  link: Link2,
  icon: Sparkles,
  chart: BarChart3,
  custom_component: Code2,
  data_list: Table,
  file_viewer: FileText,
  kanban: KanbanSquare,
  related_list: ListTree,
  calendar: CalendarDays,
  activity: MessageSquare,
  page_filter: Filter,
  repeater: Rows3,
  field: TextCursorInput,
  form: ClipboardList,
  record: SquarePen,
  button: MousePointerClick,
  // inputs (S13)
  text_input: TextCursorInput,
  number_input: Hash,
  checkbox_input: CheckSquare,
  select_input: List,
  textarea_input: Pilcrow,
};

export function paletteIcon(type: string): LucideIcon {
  return BY_TYPE[type] ?? Square;
}
